import { carouselStyles as styles } from "@hardware/Overrides/Components/ProductCompareCarousel";
import { css } from "styled-components";

styles.compareCheckbox = {
    ...styles.compareCheckbox,
    css: css`
        margin-top: auto;
        padding-bottom: 15px;
    `,
};
